module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.submited) ? _c('h3', [_vm._v(_vm._s(_vm.$t('organization.slogan')) + "\n    "), _c('small', [_c('checkbox', {
    model: {
      value: (_vm.showForm),
      callback: function($$v) {
        _vm.showForm = $$v
      },
      expression: "showForm"
    }
  }, [_c('b', {
    staticClass: "uppercase",
    staticStyle: {
      "font-size": "25px"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('yes')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }]
  }, [_vm._v(_vm._s(_vm.$t('organization.fillFields')))])], 1)]) : _c('h3', [_vm._v(_vm._s(_vm.$t('organization.yourOrganization')) + ":\n    "), _c('br'), _c('br'), _vm._v(" "), (_vm.organization.status === 'pending') ? _c('small', [_vm._v(_vm._s(_vm.$t('organization.submitted')))]) : _vm._e(), _vm._v(" "), (_vm.organization.status === 'approved') ? _c('small', [_vm._v(_vm._s(_vm.$t('organization.approved')))]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('organization.contactAdmin')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }]
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'name'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.name),
      expression: "organization.name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('organization.name')
    },
    domProps: {
      "value": (_vm.organization.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'address'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.address_line_1),
      expression: "organization.address_line_1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('organization.streetName')
    },
    domProps: {
      "value": (_vm.organization.address_line_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "address_line_1", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'address'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.address_line_2),
      expression: "organization.address_line_2"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('organization.streetNumber')
    },
    domProps: {
      "value": (_vm.organization.address_line_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "address_line_2", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'postcode'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.postcode),
      expression: "organization.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('organization.zipCode')
    },
    domProps: {
      "value": (_vm.organization.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "postcode", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'nip'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.nip),
      expression: "organization.nip"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('organization.vat')
    },
    domProps: {
      "value": (_vm.organization.nip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "nip", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'city'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.city),
      expression: "organization.city"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('organization.city')
    },
    domProps: {
      "value": (_vm.organization.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "city", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'country'
    }
  }, [(_vm.countries.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.country_id),
      expression: "organization.country_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.organization, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('country')))]), _vm._v(" "), _vm._l((_vm.countries), function(country, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": country.id
      }
    }, [_vm._v(_vm._s(country.name))])
  })], 2) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'iban'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.iban),
      expression: "organization.iban"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.submited,
      "placeholder": _vm.$t('iban')
    },
    domProps: {
      "value": (_vm.organization.iban)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "iban", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("organization.vatInfo")) + "\n  "), _c('a', {
    attrs: {
      "href": "https://europa.eu/youreurope/business/vat-customs/check-number-vies/index_pl.htm",
      "target": "blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("here")))])]), _vm._v(" "), (!_vm.organization.id) ? _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveOrganization($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("save")))]) : _vm._e(), _vm._v(" "), (_vm.created) ? _c('div', [_c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrganization($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("update")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("organization.editNote")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitOrganization($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("profile.edit.confirmOrganization")))])]) : _vm._e(), _vm._v(" "), _c('alert', {
    attrs: {
      "success": _vm.alert.success,
      "error": _vm.alert.error
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.approved) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("profile.edit.yourDocuments")) + ":")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('profile.kyc.createMangopayProfile')) + "\n    ")])]) : _vm._e()]), _vm._v(" "), (_vm.formModalOpen) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('Form', {
    attrs: {
      "user": _vm.user,
      "organization": _vm.organization
    },
    on: {
      "closeFormModal": _vm.closeFormModal,
      "openDocumentsForm": _vm.openDocumentsForm
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.documentsModalOpen) ? _c('transition', {
    attrs: {
      "name": "documentsModal"
    }
  }, [_c('modal', {
    attrs: {
      "close": _vm.closeDocumentsModal,
      "width": "80%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('profile.kyc.addDocuments')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('Documents', {
    attrs: {
      "organization": _vm.organization
    },
    on: {
      "document:created": _vm.setDocumentId
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "slot": "footer",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.formModalOpen = true;
        _vm.documentsModalOpen = false
      }
    },
    slot: "footer"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('profile.kyc.editOrganizationData')) + "\n      ")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92f1adf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organization/Edit.vue
// module id = 829
// module chunks = 1